import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { Participante } from '../../../../models/ParticipanteType';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { map, Observable, startWith } from 'rxjs';
import { ServidorPublico } from '../../../../models/ServidorPublico';
import { UltimoUsoPipe } from '../../../../pipes/ultimo-uso.pipe';
import { AsyncPipe } from '@angular/common';
import { participanteValidator } from '../../../../commons/reasignar/reasignar.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AccionTarea } from '../../../../models/Tarea';
import { TareaService } from '../../../../services/tarea.service';
import { ScnackbarData, SnackbarStyles, ToastService } from '../../../../commons/toast.service';
import { AuthService } from '../../../../services/auth.service';
import { DateService } from '../../../../shared/date.service';

@Component({
  selector: 'app-dlg-adm-reasigna',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatProgressSpinnerModule,
    MatButtonModule, MatIconModule,
    MatInputModule, MatFormFieldModule,
    FormsModule, ReactiveFormsModule,
    MatSelectModule, MatAutocompleteModule,
    UltimoUsoPipe, AsyncPipe,
  ],
  templateUrl: './dlg-adm-reasigna.component.html',
  styleUrl: './dlg-adm-reasigna.component.scss'
})
export class DlgAdmReasignaComponent {

  readonly dialogRef = inject(MatDialogRef<DlgAdmReasignaComponent>)
  readonly data = inject<any>(MAT_DIALOG_DATA);
  participantes: ServidorPublico[];
  participantesFiltered?: Observable<ServidorPublico[]>
  loading = false
  snackbarData: ScnackbarData = {}
  token: any;

  reasignarForm = new FormGroup({
    comentario: new FormControl("", {
      validators: [
        Validators.required
      ]
    }),
    participante: new FormControl<ServidorPublico>({ id: 0, usuario: "", apellidos: "", nombres: "", correo: "", estado: 0, telefono: "", telefonoMovil: "", departamento: "", cargo: "", titulo: "", ciruc: "", fechaUso: "" }, {
      validators: [Validators.required, participanteValidator()]
    }),
  })

  constructor(
    private dialog: MatDialog,
    private dateService: DateService,
    private tareaService: TareaService,
    private toast: ToastService,
    private authService: AuthService,

  ) {
    this.participantes = structuredClone(this.data.participantes);
    this.participantesFiltered = this.reasignarForm.controls.participante.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombres = typeof value === 'string' ? value : value?.nombres;
        return nombres ? this._filterParticipante(nombres as string) : this.participantes.slice();
      }),
    );
    this.token = this.authService.getTokenData();
    this.reasignarForm.controls.participante.enable()
  }

  selectAllText(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  displayParticipanteFn(participante: ServidorPublico): string {
    return participante && participante.nombres ? participante.apellidos + " " + participante.nombres : '';
  }

  private _filterParticipante(filter: string): ServidorPublico[] {
    const filterValue = filter.toLowerCase();

    return this.participantes.filter(participante =>
      participante.nombres?.toLowerCase().includes(filterValue) ||
      participante.apellidos?.toLocaleLowerCase().includes(filterValue) ||
      participante.cargo?.toLowerCase().includes(filterValue) ||
      participante.ciruc.includes(filterValue));
  }

  onCancel() {
    this.dialogRef.close();
  }

  onReasignarSubmit() {
    this.loading = true
    let accionTareas: AccionTarea[] = []
    const participante = this.reasignarForm.controls.participante.value
    const comment = this.reasignarForm.controls.comentario.value
    this.data.documentIDs.forEach((document: any) => {
      const accionTarea: AccionTarea = {
        id: document,
        idParticipante: participante!.id,
        comentario: comment! + ". Reasignado por Administrador: " + this.token.name + " el " + this.dateService.formatDate(new Date()),
        fechaExpira: ''
      }
      accionTareas.push(accionTarea)
    });

    this.tareaService.ReasignarDocumento(accionTareas).subscribe({
      next: (_) => {
        this.snackbarData.message = "Documentos reasignados"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.loading = false
        this.toast.show(this.snackbarData)
        this.dialogRef.close();
      },
      error: (_) => {
        this.snackbarData.message = "Error reasignando documento!"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.loading = false
        this.toast.show(this.snackbarData)
      }
    })
  }

}
